import { h } from 'preact'
import CloseIcon from '@components/icons/Close'

export default function ArchiveFacetsModal({ children, totalItems, buttonText, titleText }) {
	return (
		<section
			className="modal modal-facets fade-out-right"
			data-drawer-name="filters"
			data-animate-in="fade-in-right"
			data-animate-out="fade-out-right"
		>
			<header className="modal-header">
				<div type="button" className="close-icon" data-drawer-toggle="filters">
					<CloseIcon />
				</div>
				<span>Filtrera</span>
			</header>

			{children}

			<footer className="modal-footer pad-5" data-drawer-toggle="filters">
				<button type="button" className="button-primary">
					Visa {totalItems} träffar
				</button>
			</footer>
		</section>
	)
}
